export const EMPTY_STATE_NO_WEBSITES = 'EMPTY_STATE_NO_WEBSITES';
